// extracted by mini-css-extract-plugin
export default {"title":"Contacts_title__NwK6P","messengersCheck":"Contacts_messengersCheck__RuyTG"};